import * as Ajax from '../ajax/Ajax';
import moment from "moment-timezone";
import "../models/statistics/StatisticsListModel";
/**
 * 統計情報を取得します。
 *
 * @param startDate 検索開始日時
 * @param endDate 検索終了日時
 * @param includeDeleted 削除された組織を含めるか否か
 * @param includeSuspended 停止された組織を含めるか否か
  * @param fn ファンクション
 */

export function GetStatistics(startDate, endDate, includeDeleted, includeSuspended, fn) {
  Ajax.Post("StatisticsApi/GetStatistics", {
    startDate: startDate == null ? null : moment(startDate).format("YYYY-MM-DDTHH:mm:ss"),
    endDate: endDate == null ? null : moment(endDate).format("YYYY-MM-DDTHH:mm:ss"),
    includeDeleted: includeDeleted,
    includeSuspended: includeSuspended
  }, Ajax.ModelResult(fn));
}